<div
  class="min-h-[21px]"
  *transloco="let t; read 'error'">
  <div class="text-red-700 small"
       *ngIf="control?.dirty">
    <div
      *ngIf="control?.errors?.['required']" @inOutAnimation>
      {{t('required')}}
    </div>
    <div
      *ngIf="control?.errors?.['pattern']" @inOutAnimation>
      {{ formatText || t('format', { pattern: format ? '(' + format + ')' : '' })}}
    </div>
    <div
      *ngIf="control?.errors?.['email']" @inOutAnimation>
      {{t('email')}}
    </div>
    <div
      *ngIf="control?.errors?.['fileSize']" @inOutAnimation>
      {{t('file_size', { acceptedFileSizeInMB: control.errors?.['acceptedFileSizeInMB'] })}}
    </div>
    <div
      *ngIf="control?.errors?.['fileType']" @inOutAnimation>
      {{t('file_type', { acceptedFileTypes: control.errors?.['acceptedFileTypes'] })}}
    </div>
    <div
      *ngIf="control?.errors?.['invalidOIB']" @inOutAnimation>
      {{t('oib')}}
    </div>
    <div
      *ngIf="control?.errors?.['invalidPDV']" @inOutAnimation>
      {{t('pdv')}}
    </div>
    <div
      *ngIf="control?.errors?.['lessThan'] || control?.errors?.['lessThan'] === 0" @inOutAnimation>
      {{t('less_than', { number: control.errors?.['lessThan'] })}}
    </div>
    <div
      *ngIf="control?.errors?.['moreThan'] || control?.errors?.['moreThan'] === 0" @inOutAnimation>
      {{t('more_than', { number: control.errors?.['moreThan'] })}}
    </div>
    <div
      *ngIf="control?.errors?.['min']" @inOutAnimation>
      {{t('min', { number: control.errors?.['min']['min'] })}}
    </div>
    <div
      *ngIf="control?.errors?.['max']" @inOutAnimation>
      {{t('max', { number: control.errors?.['max']['max'] })}}
    </div>
    <div
      *ngIf="control?.errors?.['between']" @inOutAnimation>
      {{t('between', { min: control.errors?.['between']['min'], max: control.errors?.['between']['max'] })}}
    </div>
  </div>
</div>
